export enum SendCommandEnum {
  REBOOT = 'Reboot',
  CANCEL_SHIPMENT = 'cancelShipment',
  GET_INFO = 'getInfo',
  DIRECT_METHOD = 'directMethod',
}
